// https://vuex.vuejs.org/en/getters.html

export default {
  currencies(state) {
    return state.currencies;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  loaded(state) {
    return state.loaded;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
